export default {
  getCampaignsBudgets(state) {
    return state.campaignsBudgets;
  },
};
